import { RequestsOfDataUpdate } from "../modules"

export const RequestsOfDataUpdatePage = () => {
  return (
    <RequestsOfDataUpdate />
  )
}
